import firebase from "firebase/app";
import "firebase/firestore";

var firebaseConfig = {
  apiKey: "AIzaSyCp2pvCBne2tJNGfOcxrftVcnT3OgvmJEQ",
  authDomain: "ped-app.firebaseapp.com",
  databaseURL: "https://ped-app.firebaseio.com",
  projectId: "ped-app",
  storageBucket: "ped-app.appspot.com",
  messagingSenderId: "119229274434",
  appId: "1:119229274434:web:5c3dab105092eb94c8d0db",
  measurementId: "G-5GJD23MSQ1",
};
// Initialize Firebase
const firebaseApp = firebase.initializeApp(firebaseConfig);
const timestamp = firebase.firestore.FieldValue.serverTimestamp;

export { timestamp };
export default firebaseApp.firestore();
